import React from "react";
import { Accordion, Button, Group, Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconTicket } from "@tabler/icons-react";

type Props = {
    show: boolean;
    loading: boolean;
    error: string | null;
    onCreateExperience: () => void;
};

export default function ExperienceSection({
    show,
    loading,
    error,
    onCreateExperience,
}: Props) {
    if (!show) return null;

    return (
        <Accordion.Item value="experience">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconTicket size={18} />
                    </ThemeIcon>
                }
            >
                Sightseeing tour
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="sm">
                    <Text c="dimmed" size="sm">
                        Book your Sightseeing tour
                    </Text>

                    {error && (
                        <Paper withBorder p="sm" radius="md">
                            <Text c="red" size="sm">
                                {error}
                            </Text>
                        </Paper>
                    )}

                    <Group justify="flex-end">
                        <Button
                            color="red"
                            onClick={onCreateExperience}
                            loading={loading}
                            variant="light"
                        >
                            Opret Experience
                        </Button>
                    </Group>
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}